import { Screen1 } from './screen-1'
import { Screen2 } from './screen-2'
import { Screen3 } from './screen-3'
import { Screen4 } from './screen-4'
import { LoginScreen } from './screen-5'

const screens = {
  onboarding: [Screen1, Screen2, Screen3, Screen4],
  login: LoginScreen,
}

export default screens
